export default __webpack_public_path__ + "static/suricata-45d0357b39a4165f8cf3a8a6e12f62d7.png";